<div class="layout-menu-container">
  <ul (keydown)="onKeydown($event)" class="layout-menu" role="menu">
    <li *ngFor="let item of model; let i = index;" class="layout-menuitem-category" role="none">
      <div [attr.aria-label]="item.label" class="layout-menuitem-root-text">{{ item.label }}</div>
      <ul role="menu">
        <app-menu-item *ngFor="let child of item.items" [index]="i" [item]="child" role="none"></app-menu-item>
      </ul>
    </li>
  </ul>
</div>
